import type { TenderBoard, TenderItem, TenderWork } from "@/types/tenders";
import { apiClient } from "./client";

export const tendersApi = {
  refreshDocuments: (id: string) =>
    apiClient.post(`/api/tenders/${encodeURIComponent(id)}/documents/refresh`),
  item: (id: string) =>
    apiClient.get<TenderItem>(`/api/tenders/${encodeURIComponent(id)}`),
  board: () => apiClient.get<TenderBoard>("/api/tenders"),
  refresh: () => apiClient.post("/api/tenders/refresh"),
  save: (id: string, revision: number, work: TenderWork) =>
    apiClient.put<TenderItem>(`/api/tenders/${encodeURIComponent(id)}`, {
      revision,
      work,
    }),
  document: (id: string, documentId: string) =>
    apiClient.getBlob(
      `/api/tenders/${encodeURIComponent(id)}/documents/${encodeURIComponent(documentId)}`,
    ),
};
